import type { GridColDef } from '@mui/x-data-grid';

export const theKhoColumns: GridColDef[] = [
  { field: 'loai_kho', headerName: 'Loại dữ liệu', width: 150 },
  { field: 'xid', headerName: 'ID', width: 100 },
  { field: 'ma_unit', headerName: 'Đơn vị', width: 120 },
  { field: 'so_ct', headerName: 'Số c/từ', width: 150 },
  { field: 'ngay_ct', headerName: 'Ngày c/từ', width: 100 },
  { field: 'ma_kho', headerName: 'Mã kho', width: 120 },
  { field: 'ma_vt', headerName: 'Mã vật tư', width: 120 },
  { field: 'ten_vt', headerName: 'Tên vật tư', width: 120 },
  { field: 'ma_kh', headerName: 'Mã khách hàng', width: 150 },
  { field: 'ma_nt', headerName: 'Ngoại tệ', width: 120 },
  { field: 'px_dd', headerName: 'Đích danh', width: 120 },
  { field: 'pn_tb', headerName: 'Giá trung bình', width: 150 },
  { field: 'gia', headerName: 'Giá', width: 100 },
  { field: 'sl_xuat', headerName: 'Sl xuất', width: 120 },
  { field: 'sl_nhap', headerName: 'Sl nhập', width: 120 },
  { field: 'tien_xuat', headerName: 'Tiền xuất', width: 120 },
  { field: 'tien_nhap', headerName: 'Tiền nhập', width: 120 },
  { field: 'thue', headerName: 'Thuế', width: 100 },
  { field: 'ma_nvbh', headerName: 'Mã nhân viên bh', width: 120 },
  { field: 'ten_nvbh', headerName: 'Tên nhân viên', width: 120 },
  { field: 'tien2', headerName: 'Doanh thu', width: 120 },
  { field: 'ma_bp', headerName: 'Bộ phận', width: 120 },
  { field: 'ma_ct', headerName: 'Mã c/từ', width: 120 }
];

export const soCaiColumns: GridColDef[] = [
  { field: 'xid', headerName: 'ID', width: 100 },
  { field: 'ma_unit', headerName: 'Đơn vị', width: 120 },
  { field: 'so_ct', headerName: 'Số c/từ', width: 120 },
  { field: 'ngay_ct', headerName: 'Ngày c/từ', width: 120 },
  { field: 'ma_kh', headerName: 'Mã khách hàng', width: 150 },
  { field: 'tk', headerName: 'Tài khoản', width: 120 },
  { field: 'tk_du', headerName: 'Tk đối ứng', width: 120 },
  { field: 'tknh', headerName: 'Ngân hàng', width: 120 },
  { field: 'ma_nt', headerName: 'Ngoại tệ', width: 120 },
  { field: 'ty_gia', headerName: 'Tỷ giá', width: 100 },
  { field: 'ps_no_nt', headerName: 'Ps nợ nt', width: 120 },
  { field: 'ps_co_nt', headerName: 'Ps có nt', width: 120 },
  { field: 'ps_no', headerName: 'Ps nợ', width: 100 },
  { field: 'ps_co', headerName: 'Ps có', width: 100 },
  { field: 'edit_yn', headerName: 'Sửa', width: 80 },
  { field: 'dien_giai', headerName: 'Diễn giải', width: 200 },
  { field: 'ma_bp', headerName: 'Bộ phận', width: 120 },
  { field: 'ma_vv', headerName: 'Vụ việc', width: 120 },
  { field: 'ma_hd', headerName: 'Hợp đồng', width: 120 },
  { field: 'ma_dtt', headerName: 'Đợt thanh toán', width: 150 },
  { field: 'ma_ku', headerName: 'Khế ước', width: 120 },
  { field: 'ma_phi', headerName: 'Phí', width: 100 },
  { field: 'ma_sp', headerName: 'Sản phẩm', width: 120 },
  { field: 'ma_lsx', headerName: 'Lệnh sản xuất', width: 150 },
  { field: 'ma_cp0', headerName: 'C/p không h/lệ', width: 150 },
  { field: 'ma_ct', headerName: 'Mã c/từ', width: 120 },
  { field: 'status', headerName: 'Trạng thái', width: 120 },
  { field: 'xgroup', headerName: 'Phân loại', width: 120 }
];

export const thanhToanPhaiThuColumns: GridColDef[] = [
  { field: 'xid', headerName: 'ID', width: 100 },
  { field: 'loai_tt', headerName: 'Loại t.toán', width: 120 },
  { field: 'ma_unit', headerName: 'Đơn vị', width: 120 },
  { field: 'so_ct', headerName: 'Số c/từ', width: 120 },
  { field: 'so_ct2', headerName: 'Ký hiệu', width: 120 },
  { field: 'ngay_ct', headerName: 'Ngày c/từ', width: 120 },
  { field: 'ma_kh', headerName: 'Mã khách hàng', width: 150 },
  { field: 'tk', headerName: 'Tài khoản', width: 120 },
  { field: 'ma_nt', headerName: 'Ngoại tệ', width: 120 },
  { field: 'ty_gia', headerName: 'Tỷ giá', width: 100 },
  { field: 'han_tt', headerName: 'Hạn thanh toán', width: 150 },
  { field: 't_tt_nt', headerName: 'Tiền nt', width: 120 },
  { field: 't_tt', headerName: 'Tiền', width: 100 },
  { field: 'tt_nt', headerName: 'Thanh toán nt', width: 130 },
  { field: 'tt', headerName: 'Thanh toán', width: 120 },
  { field: 'dien_giai', headerName: 'Diễn giải', width: 200 },
  { field: 'ma_ct', headerName: 'Mã chứng từ', width: 120 }
];

export const thanhToanPhaiTraColumns: GridColDef[] = [
  { field: 'xid', headerName: 'ID', width: 100 },
  { field: 'loai_tt', headerName: 'Loại t.toán', width: 120 },
  { field: 'ma_unit', headerName: 'Đơn vị', width: 120 },
  { field: 'so_ct', headerName: 'Số c/từ', width: 120 },
  { field: 'ngay_ct', headerName: 'Ngày c/từ', width: 120 },
  { field: 'so_ct0', headerName: 'Số hóa đơn', width: 130 },
  { field: 'ngay_ct0', headerName: 'Ngày hóa đơn', width: 130 },
  { field: 'ma_kh', headerName: 'Mã khách hàng', width: 150 },
  { field: 'tk', headerName: 'Tài khoản', width: 120 },
  { field: 'ma_nt', headerName: 'Ngoại tệ', width: 120 },
  { field: 'ty_gia', headerName: 'Tỷ giá', width: 100 },
  { field: 't_tt_nt', headerName: 'Tiền nt', width: 120 },
  { field: 't_tt', headerName: 'Tiền', width: 100 },
  { field: 'tt_nt', headerName: 'Thanh toán nt', width: 130 },
  { field: 'tt', headerName: 'Thanh toán', width: 120 },
  { field: 'dien_giai', headerName: 'Diễn giải', width: 200 },
  { field: 'ma_ct', headerName: 'Mã chứng từ', width: 120 }
];

export const thueVatDauRaColumns: GridColDef[] = [
  { field: 'xid', headerName: 'ID', width: 100 },
  { field: 'ma_unit', headerName: 'Đơn vị', width: 120 },
  { field: 'ngay_ct', headerName: 'Ngày c/từ', width: 120 },
  { field: 'so_ct', headerName: 'Số c/từ', width: 120 },
  { field: 'so_ct2', headerName: 'Ký hiệu', width: 120 },
  { field: 'ma_kh', headerName: 'Mã khách hàng', width: 150 },
  { field: 'ten_kh_thue', headerName: 'Tên khách hàng', width: 200 },
  { field: 'dia_chi', headerName: 'Địa chỉ', width: 200 },
  { field: 'ma_so_thue', headerName: 'Mã số thuế', width: 150 },
  { field: 't_tien_nt2', headerName: 'Tiền hàng nt', width: 130 },
  { field: 't_tien2', headerName: 'Tiền hàng', width: 120 },
  { field: 'ma_thue', headerName: 'Mã thuế', width: 120 },
  { field: 'thue_suat', headerName: 'Thuế suất', width: 120 },
  { field: 't_thue_nt', headerName: 'Tiền thuế', width: 130 },
  { field: 't_thue', headerName: 'Tiền thuế nt', width: 120 },
  { field: 'tk_thue_co', headerName: 'Tk thuế', width: 120 },
  { field: 'tk_du', headerName: 'Tk đối ứng', width: 120 },
  { field: 'ghi_chu', headerName: 'Ghi chú', width: 200 },
  { field: 'ma_vv', headerName: 'Mã vụ việc', width: 120 },
  { field: 'ma_ct', headerName: 'Mã chứng từ', width: 120 },
  { field: 'status', headerName: 'Trạng thái', width: 120 }
];

export const thueVatDauVaoColumns: GridColDef[] = [
  { field: 'xid', headerName: 'ID', width: 100 },
  { field: 'ma_unit', headerName: 'Đơn vị', width: 120 },
  { field: 'ngay_ct', headerName: 'Ngày c/từ', width: 120 },
  { field: 'so_ct', headerName: 'Số c/từ', width: 120 },
  { field: 'so_ct0', headerName: 'Số hóa đơn', width: 130 },
  { field: 'ngay_ct0', headerName: 'Ngày hóa đơn', width: 130 },
  { field: 'so_ct2', headerName: 'Ký hiệu', width: 120 },
  { field: 'ma_kh', headerName: 'Mã khách hàng', width: 150 },
  { field: 'ten_kh_thue', headerName: 'Tên khách hàng', width: 200 },
  { field: 'dia_chi', headerName: 'Địa chỉ', width: 200 },
  { field: 'ma_so_thue', headerName: 'Mã số thuế', width: 150 },
  { field: 't_tien_nt', headerName: 'Tiền hàng nt', width: 130 },
  { field: 't_tien', headerName: 'Tiền hàng', width: 120 },
  { field: 'ma_thue', headerName: 'Mã thuế', width: 120 },
  { field: 'thue_suat', headerName: 'Thuế suất', width: 120 },
  { field: 't_thue_nt', headerName: 'Tiền thuế nt', width: 130 },
  { field: 't_thue', headerName: 'Tiền thuế', width: 120 },
  { field: 'tk_thue_no', headerName: 'Tk thuế', width: 120 },
  { field: 'ghi_chu', headerName: 'Ghi chú', width: 200 },
  { field: 'ma_vv', headerName: 'Mã vụ việc', width: 120 },
  { field: 'ma_ct', headerName: 'Mã chứng từ', width: 120 },
  { field: 'status', headerName: 'Trạng thái', width: 120 }
];
